module.exports = __webpack_public_path__ + "src/assets/games/11/357.jpg";